module.exports = "//public.zight.com/packs/media/images/annotate/arrow-3a44a20d754a9cfcfe442d473879b41e.svg";